import { render, staticRenderFns, recyclableRender, components } from "./u-cell.vue?vue&type=template&id=913eaa32&scoped=true&"
var renderjs
import script from "./u-cell.vue?vue&type=script&lang=js&"
export * from "./u-cell.vue?vue&type=script&lang=js&"
import style0 from "./u-cell.vue?vue&type=style&index=0&id=913eaa32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913eaa32",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-cell/u-cell.vue"
export default component.exports